/**
 * This source code is quoted from rc-slider.
 * homepage: https://github.com/react-component/slider
 */
// import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect, useCallback } from 'react';
// import {findDOMNode} from 'react-dom';
import Tooltip from '../../wui-tooltip/src';
// import {sliderPropTypes} from './common/createSlider';
// import Tooltip from '../../wui-tooltip/src2';
// import Tooltip from 'bee-tooltip';
import Handle from './Handle';
import type { GenericSliderProps, ComponentWrapperProps, HandleProps} from './iSlider';

function createSliderWithTooltip<Props extends GenericSliderProps>(
    Component: React.ComponentClass<Props>,
) {
    const ComponentWrapper: React.FC<ComponentWrapperProps & React.ComponentProps<typeof Component>> = (props) => {
        const [visibles, setVisibles] = useState<{[key: number]: boolean}>({});
        const [index, setIndex] = useState<number | undefined>(undefined);
        const handlesRefs = useRef<{[key: number]: any}>({});
        const tooltipRef = useRef<any>({});

        // 默认属性处理
        const {
            tipFormatter = (value: number) => value,
            handleStyle = [{}],
            tipProps = {},
            ...restProps
        } = props;

        // 更新 Tooltip 位置
        const updateTooltipPosition = useCallback(() => {
            if (tooltipRef.current[index!]) {
                tooltipRef.current[index!].forcePopupAlign && tooltipRef.current[index!].forcePopupAlign();
            }
        }, [index]);

        // componentDidMount 和 componentDidUpdate 的效果
        useEffect(() => {
            updateTooltipPosition();
        });

        // 获取默认位置
        const getDefaultPosition = useCallback(() => {
            return document.body;
        }, []);

        // 处理 Tooltip 可见性变化
        const handleTooltipVisibleChange = useCallback((idx: number, visible: boolean) => {
            setVisibles(prevVisibles => ({
                ...prevVisibles,
                [idx]: visible,
            }));
            setIndex(idx);
        }, []);

        // 保存 Handle 引用
        const saveHandle = useCallback((idx: number, handle: any) => {
            handlesRefs.current[idx] = handle;
        }, []);

        // 获取 DOM 节点 (暂时保留但未使用)
        // const getDOMNode = useCallback((idx: number) => {
        //     let hadleDOm = document.querySelector(`[domKey="${handlesRefs.current[idx]?.props?.domKey}"]`);
        //     return hadleDOm;
        // }, []);

        // Handle with Tooltip 渲染函数
        const handleWithTooltip = useCallback(({value, dragging, index: handleIndex, disabled, ...handleRestProps}: HandleProps & {index: number, value: number}) => {
            const {
                getTooltipPopupContainer,
                tooltipPlacement = 'top',
                tooltipVisible,
            } = props;
            const {
                prefixCls = 'u-slider-tooltip',
                overlay = tipFormatter(value),
                ...restTooltipProps
            } = tipProps;

            const isVisible = () => {
                if (props.hasOwnProperty('tooltipVisible')) {
                    return tooltipVisible;
                } else {
                    return (!disabled && (visibles[handleIndex] || dragging));
                }
            };

            return (
                <Tooltip
                    {...restTooltipProps}
                    className={prefixCls}
                    overlay={overlay}
                    shouldUpdatePosition={true}
                    visible={isVisible()}
                    key={handleIndex}
                    ref={ref => tooltipRef.current[handleIndex] = ref}
                    // getPopupContainer={() => getDOMNode(handleIndex)}
                    placement={tooltipPlacement}
                    getPopupContainer={getTooltipPopupContainer || getDefaultPosition}
                >
                    <Handle
                        {...handleRestProps}
                        style={{
                            ...handleStyle[0],
                        }}
                        ref={(ref: any) => saveHandle(handleIndex, ref)}
                        value={value}
                        onMouseEnter={() => handleTooltipVisibleChange(handleIndex, true)}
                        onMouseLeave={() => handleTooltipVisibleChange(handleIndex, false)}
                    />
                </Tooltip>
            );
        }, [tipFormatter, handleStyle, tipProps, props, updateTooltipPosition, visibles, getDefaultPosition, saveHandle, handleTooltipVisibleChange]);

        return <Component {...(restProps as any)} handle={handleWithTooltip} tipFormatter={tipFormatter} handleStyle={handleStyle} tipProps={tipProps} />;
    };

    return ComponentWrapper;
}

export default createSliderWithTooltip as any;